import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { ListDivider } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { DropdownLinkItem } from '../../../components/DropdownLinkItem';
import { Home } from '../../../routes/config/Home';
import { useAnnotationPermissions } from '../annotation.permissions';

export const BackToProjectContainer = observer((): ReactElement => {
  const annotationPermissions = useAnnotationPermissions();
  const { t } = useTranslator();

  const { workspaceId, projectId } = useParams<{ projectId: string; workspaceId: string }>();

  return annotationPermissions.canGoBackToProject().allowed ? (
    <>
      <DropdownLinkItem
        linkTo={Home.Projects.Details.Overview.withParams({
          workspaceId,
          projectId,
        })}
      >
        <FontAwesomeIcon icon={faArrowLeft} /> {t('back_to_project')}
      </DropdownLinkItem>
      <ListDivider />
    </>
  ) : (
    <></>
  );
});
